import { forwardRef, type ComponentPropsWithoutRef, type ReactNode } from 'react'

type AppCardProps = ComponentPropsWithoutRef<'div'> & {
  name: string
  description?: string | null
  cardMenu?: ReactNode
  cardButtons?: ReactNode
  cardDetails?: ReactNode
  icon: ReactNode
}

export const AppCard = forwardRef<HTMLDivElement, AppCardProps>(function AppCard(
  { name, description, cardMenu, cardButtons, cardDetails, icon, className, ...divProps },
  ref
) {
  const leftIcon = (
    <div className="flex h-12 w-12 flex-shrink-0 flex-grow-0 items-center justify-center self-start rounded-full bg-muted p-2 text-foreground/50">
      {icon}
    </div>
  )

  const titleDescription = (
    <div className="flex flex-col justify-between gap-1">
      <div className="text-base">{name}</div>
      {description && <div className="text-xs font-light">{description}</div>}
    </div>
  )

  return (
    <div
      ref={ref}
      className={['grid grid-cols-[1fr_4fr_1fr] gap-2 bg-background p-4 shadow', className]
        // className={['grid grid-cols-[1fr_4fr_1fr] gap-2 rounded-lg bg-background p-4 shadow', className]
        .filter(Boolean)
        .join(' ')}
      {...divProps}
    >
      {leftIcon}
      {titleDescription}
      {cardMenu ?? <div />}
      {cardDetails ? <div className="col-span-2 col-start-2 mt-1">{cardDetails}</div> : null}
      {cardButtons ? (
        <div className="col-span-2 col-start-2 flex flex-row justify-end gap-2 border-t pt-3">{cardButtons}</div>
      ) : null}
    </div>
  )
})
